import React from "react";
import MetricsCardsSkeleton from "./MetricsCardsSkeleton";

const CampaignDetailSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-3 h-full animate-pulse">
      {/* Header Skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-2 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gray-200"></div>
          <div className="w-6 h-6 rounded bg-gray-200"></div>
          <div className="w-48 h-6 rounded bg-gray-200"></div>
          <div className="hidden sm:block w-16 h-5 rounded-md bg-gray-200"></div>
          <div className="hidden sm:block w-20 h-3 rounded bg-gray-200"></div>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
          <div className="flex-1 sm:flex-none sm:w-64 h-[38px] rounded-lg bg-gray-200"></div>
          <div className="w-full sm:w-32 h-[38px] rounded-lg bg-gray-200"></div>
        </div>
      </div>

      {/* Metrics Grid Skeletons */}
      <MetricsCardsSkeleton count={4} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Chart Section Skeleton */}
        <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-gray-100 dark:border-neutral-700 p-4 lg:col-span-2">
           <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 rounded bg-gray-200"></div>
              <div className="w-40 h-5 rounded bg-gray-200"></div>
           </div>
           <div className="h-[300px] bg-gray-100 dark:bg-neutral-600 rounded-lg"></div>
        </div>

        {/* Campaign Info Skeleton */}
        <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-gray-100 dark:border-neutral-700 p-4">
           <div className="flex items-center gap-2 mb-6">
              <div className="w-6 h-6 rounded bg-gray-200"></div>
              <div className="w-32 h-5 rounded bg-gray-200"></div>
           </div>
           <div className="space-y-4">
             {[1, 2, 3].map((i) => (
                <div key={i} className="flex justify-between items-center pb-3 border-b border-gray-50">
                   <div className="w-24 h-4 rounded bg-gray-200"></div>
                   <div className="w-24 h-4 rounded bg-gray-200"></div>
                </div>
             ))}
           </div>
        </div>
      </div>

      {/* Country Breakdown Table Skeleton */}
      <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-gray-100 dark:border-neutral-700 overflow-hidden">
        <div className="p-4 border-b border-gray-100 dark:border-neutral-700 flex items-center gap-2 bg-gray-50 dark:bg-neutral-800/50">
           <div className="w-6 h-6 rounded bg-gray-200"></div>
           <div className="w-32 h-5 rounded bg-gray-200"></div>
        </div>
        <div className="p-4 space-y-4">
           {/* Table Header */}
           <div className="flex justify-between items-center pb-2 border-b border-gray-100 dark:border-neutral-700">
              <div className="w-24 h-4 rounded bg-gray-200"></div>
              <div className="w-20 h-4 rounded bg-gray-200"></div>
              <div className="w-20 h-4 rounded bg-gray-200"></div>
              <div className="w-20 h-4 rounded bg-gray-200"></div>
              <div className="w-20 h-4 rounded bg-gray-200"></div>
           </div>
           {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex justify-between items-center">
                 <div className="w-32 h-4 rounded bg-gray-100 dark:bg-neutral-600"></div>
                 <div className="w-20 h-4 rounded bg-gray-100 dark:bg-neutral-600"></div>
                 <div className="w-20 h-4 rounded bg-gray-100 dark:bg-neutral-600"></div>
                 <div className="w-20 h-4 rounded bg-gray-100 dark:bg-neutral-600"></div>
                 <div className="w-16 h-4 rounded bg-gray-100 dark:bg-neutral-600"></div>
              </div>
           ))}
        </div>
      </div>
    </div>
  );
};

export default CampaignDetailSkeleton;
